import Actions from 'assets/icons/fa/check-square.svg'

export default Actions
